import { Stepper, StepperStep } from "@dgs/core";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StepperHeader } from "../../shared/ui/StepperHeader";

export type CreateContactStepKey = "masterData" | "details" | "companies" | "addresses" | "additional";

interface ContactStep extends StepperStep {
	key: CreateContactStepKey;
}

interface Props {
	activeStep: CreateContactStepKey;
	excludeDetailsStep: boolean;
}

export const createContactSteps: ContactStep[] = [
	{ label: "Master data", optional: false, key: "masterData" },
	{ label: "Details", optional: false, key: "details" },
	{ label: "Companies", optional: true, key: "companies" },
	{ label: "Addresses", optional: true, key: "addresses" },
	{ label: "Additional", optional: true, key: "additional" },
];

export const CreateContactStepper: FC<Props> = ({ activeStep, excludeDetailsStep }) => {
	const { t } = useTranslation();
	const steps = useMemo(
		() => (excludeDetailsStep ? createContactSteps.filter((step) => step.key !== "details") : createContactSteps),
		[excludeDetailsStep],
	);
	const activeIndex = steps.findIndex((s) => s.key === activeStep);

	return (
		<StepperHeader>
			<Stepper currentStepIndex={activeIndex} steps={steps.map((s) => ({ ...s, label: t(s.label as string) }))} />
		</StepperHeader>
	);
};
